import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Network } from "@capacitor/network";
import { App } from "@capacitor/app";
import { Keyboard } from "@capacitor/keyboard";
import { Browser } from "@capacitor/browser";

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();

// Initialize mobile features
export const initMobileApp = async () => {
  if (isNative) {
    // Set status bar style
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setOverlaysWebView({ overlay: false });

    // Hide splash screen
    setTimeout(async () => {
      await SplashScreen.hide();
    }, 2000);

    // Handle keyboard
    Keyboard.setAccessoryBarVisible({ isVisible: true });

    // Listen for back button on Android
    if (platform === "android") {
      App.addListener("backButton", ({ canGoBack }) => {
        if (!canGoBack) {
          App.exitApp();
        }
      });
    }
  }
};

// Network status
export const getNetworkStatus = async () => {
  return await Network.getStatus();
};

// Open URLs in browser
export const openBrowser = async (url: string) => {
  if (isNative) {
    await Browser.open({ url });
  } else {
    window.open(url, "_blank");
  }
};

// Share functionality
export const shareContent = async (options: {
  title?: string;
  text?: string;
  url?: string;
  dialogTitle?: string;
}) => {
  if (isNative) {
    const { Share } = await import("@capacitor/share");
    await Share.share(options);
  } else if (navigator.share) {
    await navigator.share(options);
  }
};
